export const DescriptionBulletList = ({ items }: { items: string[] | null }) => {
  return (
    <div className='text-md text-gray-500 [&_p]:mb-3'>
      <ul className='list-outside list-disc ml-5'>
        {items?.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
};
